import { fmtDuration } from "../model/run";
import { useApp } from "../state/store";

function signe(d: number): string {
  if (Math.abs(d) < 0.5) return "identique au tracé de référence";
  const s = d > 0 ? "+" : "−";
  return `${s} ${fmtDuration(Math.abs(d))} par rapport au tracé de référence`;
}

/** Le chiffre, énorme : temps bout en bout et vitesse commerciale, en direct. */
export function EnTete() {
  const route = useApp((s) => s.route)!;
  const result = useApp((s) => s.result);
  const reference = useApp((s) => s.reference);
  const detail = useApp((s) => s.detailOuvert);
  const onglet = useApp((s) => s.onglet);
  const toggleDetail = useApp((s) => s.toggleDetail);
  if (!result) return null;
  const n = result.stops.length;
  const delta = reference ? result.T - reference.T : 0;
  return (
    <section className="entete">
      <p className="entete-ligne">
        <strong>{n} gares</strong> · {route.termini[0]} → {route.termini[1]} · {(result.length_m / 1000).toFixed(0)} km
      </p>
      <p className="entete-chiffre">
        <span className="temps">{fmtDuration(result.T)}</span>
        <span className="vc">
          <abbr title="vitesse commerciale : distance / temps, arrêts compris">Vc</abbr> {result.vc_kmh.toFixed(0)} km/h
        </span>
      </p>
      <p className={"entete-delta" + (delta > 0.5 ? " plus" : delta < -0.5 ? " moins" : "")}>{signe(delta)}</p>
      <button type="button" className="lien" onClick={toggleDetail}>
        {detail && onglet === "gares" ? "▾" : "▸"} détail par tronçon
      </button>
    </section>
  );
}
